// extracted by mini-css-extract-plugin
export default {"label":"styles_label__nsxhT","checkbox":"styles_checkbox__+Uvm0"};